import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {BmDunningTypeTriggerBaseComponent} from "../bm-dunning-type-trigger-base.component";

@Component({
    selector: 'bm-dunning-type-trigger-side',
    templateUrl: './bm-dunning-type-trigger-side.component.html',
    standalone: false
})
export class BmDunningTypeTriggerSideComponent extends BmDunningTypeTriggerBaseComponent implements OnInit, OnChanges, OnDestroy {

    busy: boolean;  // indicator whether the component is busy
    initialized: boolean; // indicator whether the component was initialized



    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
